// Copyright (c) 2019 Deere & Company

import Notifications, { getNotificationsDefaultState } from './notifications';
import t from 'tcomb';

const NotificationLanguagePair = t.struct({
    language: t.String,
    notifications: t.list(Notifications, 'Notifications'),
}, {
    name: 'NotificationLanguagePair',
    strict: false,
});

export const getDefaultState = () => new NotificationLanguagePair({
    language: '',
    notifications: [getNotificationsDefaultState()],
});

export default NotificationLanguagePair;
